__turbopack_context__.v({
  "button": "CollectionSection-module__eG_y2q__button",
  "buttonDesktop": "CollectionSection-module__eG_y2q__buttonDesktop",
  "buttonMobile": "CollectionSection-module__eG_y2q__buttonMobile",
  "items": "CollectionSection-module__eG_y2q__items",
  "right": "CollectionSection-module__eG_y2q__right",
  "section": "CollectionSection-module__eG_y2q__section",
  "title": "CollectionSection-module__eG_y2q__title",
  "topBar": "CollectionSection-module__eG_y2q__topBar",
});
